import { Injectable } from '@angular/core';
//import {Response} from '@angular/http';
import {BehaviorSubject, Observable} from 'rxjs';

import {PortalApiService} from '../../../../shared/services/api/portal-api.service';
import {CommonApiService} from '../../../../shared/services/api/common-api.service';
//import {PortalUserStateService} from '../../../../shared/services/portal-user-state.service';
import {PractitionerMocksService} from '../../../../shared/services/mocks/practitioner-mocks.service';
import {AppSettingsService} from '../../../../shared/services/app-settings.service';
import { finalize, map } from 'rxjs/operators';

const apiEndpoints = {  
  newDocument: 'practitionerFile/{personId}',
  getDocument: 'practitionerFile/{personId}'
}

@Injectable()
export class UploadDocumentsService {

  constructor(private appSettings: AppSettingsService,
    private portalApiService: PortalApiService,
    private commonApi: CommonApiService) { }

  
    uploadNewDocument(id: string, data: any): Observable<any> {
      return this.portalApiService.post(apiEndpoints.newDocument.replace('{personId}', id), data).pipe(
        map((res: Response) => this.handleApiResponse(res)),
        finalize(() => null)
      );
    }
    
    getDocuments(id: string): Observable<any> {
      return this.portalApiService.get(apiEndpoints.getDocument.replace('{personId}', id)).pipe(
        map((res: Response) => this.handleApiResponse(res)),
        finalize(() => null)
      );
    }

  private handleApiResponse(response:Response): any {
    try {
      return response;
    }
    catch (e) {
      if (this.appSettings.IsDebugEnabled) console.log(e);
      return null;
    }
  }

}
